export default __webpack_public_path__ + "static/media/topic2-quiz-bg.ddce8168.png";